// This file is generated by the openedx/frontend-platform's "intl-import.js" script.
//
// Refer to the i18n documents in https://docs.openedx.org/en/latest/developers/references/i18n.html to update
// the file and use the Micro-frontend i18n pattern in new repositories.
//

import messagesOfPtLanguage from './pt.json';
import messagesOfPtPtLanguage from './pt_PT.json';

export default {
  'pt': messagesOfPtLanguage,
  'pt-pt': messagesOfPtPtLanguage,
};
